import { RouteConfig } from 'react-router-config';

// import Show from './pages/Show';
import ShowsIndex from './pages/ShowsIndex';
import showsIndexController from './pages/ShowsIndex/showsIndexController';
// import Simulcast from './pages/Simulcast';

const Routes: RouteConfig[] = [
    // {
    //     path: '/shows/:show/:video?',
    //     component: Show,
    // },
    {
        path: '/videos',
        component: ShowsIndex,
        controller: showsIndexController,
        exact: true,
    },
    // {
    //     path: '/simulcast',
    //     component: Simulcast,
    //     exact: true,
    // },
];

export default Routes;
